// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:992px){.staff-navbar[data-v-2fd7521c]{max-width:220px}}", ""]);
// Exports
module.exports = exports;
